import { Money } from '@dreryk/money-common-api';

import { TextView } from '@dreryk/react-components';
import { getCustomFormattingContext, priceFormatter } from '@dreryk/react-common';

import { translationKeys } from '../translations';

type AdvancePaymentRequiredAmountTextViewProps = Readonly<{ requiredAmount: Money }>;

export const AdvancePaymentRequiredAmountTextView = (props: AdvancePaymentRequiredAmountTextViewProps): JSX.Element => {
   return (
      <TextView testId={'advancePaymentRequiredAmount'} label={translationKeys.advancePaymentRequiredAmount}>
         {priceFormatter(
            props.requiredAmount.asNumber(),
            getCustomFormattingContext({
               options: {
                  currency: 'PLN',
                  stripDecimalZeroes: true,
               },
            })
         )}
      </TextView>
   );
};
